export default "__VITE_ASSET__DmFpvInA__"